/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage,
  visiblePages = 10 // Número de páginas visibles al mismo tiempo
}) => {
  // Lógica para mostrar botones limitados
  const getPageNumbers = () => {
    const pages = [];

    // Si hay menos páginas que visiblePages, mostrar todas
    if (pageCount <= visiblePages) {
      for (let i = 0; i < pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Páginas iniciales
      if (pageIndex < visiblePages - 1) {
        for (let i = 0; i < visiblePages - 2; i++) {
          pages.push(i);
        }
        pages.push('...', pageCount - 1); // Muestra ... al final
      }
      // Páginas intermedias
      else if (pageIndex >= visiblePages - 1 && pageIndex < pageCount - visiblePages + 1) {
        pages.push(0, '...'); // Muestra ... al inicio
        for (let i = pageIndex - 3; i <= pageIndex + 3; i++) {
          pages.push(i);
        }
        pages.push('...', pageCount - 1); // Muestra ... al final
      }
      // Páginas finales
      else {
        pages.push(0, '...'); // Muestra ... al inicio
        for (let i = pageCount - (visiblePages - 1); i < pageCount; i++) {
          pages.push(i);
        }
      }
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <Flex alignItems="center" justifyContent="center">
      {/* Botón anterior */}
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => previousPage()}
        className={classNames({
          disabled: !canPreviousPage
        })}
      >
        <FontAwesomeIcon icon="chevron-left" />
      </Button>

      {/* Lista de páginas */}
      <ul className="pagination mb-0 mx-2" style={{ display: 'flex', gap: '0.5rem' }}>
        {pages.map((page, index) => (
          <li key={index} className={classNames({ active: pageIndex === page })}>
            {typeof page === 'number' ? (
              <Button
                size="sm"
                variant="falcon-default"
                className={classNames('page', {
                  'me-2': index + 1 !== pageCount
                })}
                onClick={() => gotoPage(page)}
              >
                {page + 1}
              </Button>
            ) : (
              <span className="dots">...</span>
            )}
          </li>
        ))}
      </ul>

      {/* Botón siguiente */}
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => nextPage()}
        className={classNames({
          disabled: !canNextPage
        })}
      >
        <FontAwesomeIcon icon="chevron-right" />
      </Button>
    </Flex>
  );
};

export default AdvanceTablePagination;